import { cn } from "../../utils/tailwindUtils";
import { modalFieldLabelClass } from "../../components/ui/fieldStyles";

export const enrolmentStatusStyles = {
    active: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
    completed: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300",
    withdrawn: "bg-gray-100 text-gray-700 dark:bg-gray-700/40 dark:text-gray-200",
};

export const enrolmentStatusLabels = {
    active: "Active",
    completed: "Completed",
    withdrawn: "Withdrawn",
};

export const phaseStatusStyles = {
    not_started: "bg-gray-100 text-gray-600 dark:bg-gray-700/40 dark:text-gray-300",
    in_progress: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
    completed: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300",
    evaluated: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300",
};

export const phaseStatusLabels = {
    not_started: "Not started",
    in_progress: "In progress",
    completed: "Completed",
    evaluated: "Signed off",
};

export const StatusPill = ({ value, styles, labels }) => (
    <span className={cn("px-2 py-0.5 text-xs font-medium rounded-full capitalize", styles[value] || "bg-gray-100 text-gray-700")}>
        {labels[value] || value || "-"}
    </span>
);

export const EnrolmentStatusPill = ({ value }) => (
    <StatusPill value={value} styles={enrolmentStatusStyles} labels={enrolmentStatusLabels} />
);

export const PhaseStatusPill = ({ value }) => (
    <StatusPill value={value} styles={phaseStatusStyles} labels={phaseStatusLabels} />
);

export const ModalField = ({ label, htmlFor, required, hint, children, className }) => (
    <div className={cn("space-y-2", className)}>
        {label && (
            <label htmlFor={htmlFor} className={cn(modalFieldLabelClass, "flex items-center gap-1")}>
                {label}
                {required ? <span className="text-red-500">*</span> : null}
            </label>
        )}
        {children}
        {hint ? <p className="text-xs text-gray-500 dark:text-gray-400">{hint}</p> : null}
    </div>
);

export const employeeOption = (employee) => {
    const name = employee.display_name
        || `${employee.first_name || ""} ${employee.last_name || ""}`.trim()
        || `Employee ${employee.id}`;
    return {
        value: employee.id,
        label: employee.employee_id ? `${name} (${employee.employee_id})` : name,
    };
};

export const programTrainingCount = (program) =>
    (program?.phases || []).reduce((sum, phase) => sum + (phase.tasks?.length || 0), 0);

export const ProgramPreview = ({ program }) => {
    if (!program) return null;
    const phases = program.phases || [];
    const trainings = programTrainingCount(program);
    return (
        <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 px-3 py-3 space-y-2">
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
                <span>{program.duration_weeks ? `${program.duration_weeks} weeks` : "No duration set"}</span>
                <span>{program.department || "All departments"}</span>
                <span>{phases.length} phase{phases.length === 1 ? "" : "s"}</span>
                <span>{trainings} training{trainings === 1 ? "" : "s"}</span>
                {program.default_mentor ? <span>Mentor: {program.default_mentor}</span> : null}
            </div>
            {program.description ? (
                <p className="text-xs text-gray-600 dark:text-gray-300">{program.description}</p>
            ) : null}
            {phases.length > 0 && (
                <ol className="space-y-1">
                    {phases.map((phase) => (
                        <li key={phase.id} className="text-xs text-foreground">
                            <span className="font-medium">{phase.sequence}. {phase.name}</span>
                            <span className="text-muted-foreground">
                                {phase.duration_weeks ? ` · ${phase.duration_weeks}w` : ""}
                                {` · ${phase.tasks?.length || 0} training${(phase.tasks?.length || 0) === 1 ? "" : "s"}`}
                            </span>
                        </li>
                    ))}
                </ol>
            )}
        </div>
    );
};
